/**
 * Brand-level constants — single source of truth for values that appear
 * in multiple places across the public site (founded year, company name, etc.).
 *
 * Add any brand-level string here rather than scattering literals across pages.
 */
export const BRAND = {
  foundedYear: 2025,
  companyName: "Corgi ETFs",
} as const;
